// import * as R from "ramda";
import {
  all,
  fork,
  put,
  takeEvery,
  select,
  cancel,
  take
} from "redux-saga/effects";
import { actions } from "./model";
import { SIDEBAR_INSTANCE_ID } from "./constants";
import { actions as sliderSidebarActions } from "ui-kit/SliderSidebar/model";
import {
  actions as SearchbarActions,
  getters as SearchbarGetters
} from "../../../../../ui-kit/SearchBar";

const openResourcesFlyOver = function*() {
  yield put(
    sliderSidebarActions.setIsDrawerOpen(true, {
      meta: { instanceId: SIDEBAR_INSTANCE_ID }
    })
  );
};

const closeResourcesFlyOver = function*() {
  yield put(
    sliderSidebarActions.setIsDrawerOpen(false, {
      meta: { instanceId: SIDEBAR_INSTANCE_ID }
    })
  );
};

const setSearchTerm = function*({}) {
  const searchTerm = yield select(SearchbarGetters.searchTerm);
  yield put(actions.setSearchTerm(searchTerm));
};

const watchInit = function*() {
  yield takeEvery(actions.openResourcesFlyOver.type, openResourcesFlyOver);
};

const watchCloseResourcesFlyOver = function*() {
  yield takeEvery(actions.closeResourcesFlyOver.type, closeResourcesFlyOver);
};

const watchSearch = function*() {
  let searchTask;
  for (;;) {
    const action = yield take([
      SearchbarActions.clearSearch.type,
      SearchbarActions.setSearchTerm.type
    ]);

    if (searchTask) {
      yield cancel(searchTask);
    }

    searchTask = yield fork(setSearchTerm, action);
  }
};

const rootSaga = function*() {
  yield all([
    fork(watchInit),
    fork(watchCloseResourcesFlyOver),
    fork(watchSearch)
  ]);
};
export default rootSaga;
